/**
 * CompletionScreen Component
 * Displayed when survey is completed successfully
 * Shows a friendly thank-you message - results are NOT shown to employee
 */

import React from 'react';

/**
 * Survey completion confirmation screen
 * @param {Object} props
 * @param {Function} props.onStartNew - Callback to start a new survey (optional)
 * @param {string} props.employeeName - Name of the employee who completed survey
 */
function CompletionScreen({ onStartNew, employeeName }) {
    return (
        <div className="completion-screen">
            <div className="completion-content">
                {/* Success Icon */}
                <div className="completion-icon">
                    <span className="celebration">🎉</span>
                </div>

                {/* Main Message */}
                <h1>Thank You{employeeName ? `, ${employeeName}` : ''}!</h1>
                <p className="completion-subtitle">
                    Your Work Study has been completed successfully.
                </p>

                {/* Information Box */}
                <div className="completion-info simple">
                    <div className="info-card featured">
                        <div className="info-card-icon">📋</div>
                        <h3>What Happens Next?</h3>
                        <p>
                            <strong>People Operations</strong> will review your responses and 
                            compile insights from across the organization. They'll be in touch 
                            to share findings and discuss any opportunities to better 
                            support you in your role.
                        </p>
                    </div>
                </div>

                {/* Reassurance Message */}
                <div className="reassurance-section">
                    <div className="reassurance-icon">💡</div>
                    <div className="reassurance-text">
                        <p>
                            <strong>Remember:</strong> This Work Study was about understanding 
                            your work, not evaluating it. Your honest responses help us 
                            identify ways to better support you and your team.
                        </p>
                    </div>
                </div>

                {/* Contact Information */}
                <div className="contact-section">
                    <h3>Questions?</h3>
                    <p>
                        If you have any questions about the Work Study or what happens next, 
                        please reach out to <strong>People Operations</strong> or your manager.
                    </p>
                </div>

                {/* Close/Finish Button */}
                <div className="completion-actions">
                    <p className="close-message">
                        You can safely close this window now. Have a great day! 👋
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CompletionScreen;
